import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { StateMessageFactory } from "@/components/shared/state-messages/StateMessageFactory";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/reset-password/success")({
  component: ResetPasswordSuccess,
});

function ResetPasswordSuccess() {
  return (
    <div className="h-screen grid grid-col-1 p-14 items-center col-span-full">
      <div className="row-span-1 flex justify-center">
        <MimiatHorizontalLogo />
      </div>
      <div className="row-span-8 flex justify-center">
        {StateMessageFactory("reset-password-success")}
      </div>
    </div>
  );
}
